<template>
  <!-- 常见问题页面 -->
  <div class="box1">
    <!-- 搜索 -->
    <div class="search-box">
      <div class="search">
        <search :Tips="Tips" @handelScreen="handelScreen"></search>
      </div>
    </div>
    <div class="keyword">
      <p class="title-Individual-center">
        <span class="firm-clickable" v-if="CurrentPage == '/knowledge'" @click="handelReturn"
          >知识区</span
        ><span class="firm-clickable" v-else @click="handelReturn">常见问题</span>
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center">{{ dataArr.name }}</span>
      </p>
    </div>

    <!-- 主体 -->
    <div class="Core">
      <div class="all-problem">
        <p class="title">{{ dataArr.name }}</p>
        <p class="num-p">阅读量：{{ dataArr.readCount }}</p>
        <div class="ql-editor ql-blank" v-html="dataArr.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  postGetProblemInfoById, // 问题详情
  postGetKnowledgeArticleById, // 知识区文章详情
} from "../../../assets/api/indexl";

// 引入搜索组件
import search from "../../../components/search.vue";
export default {
  components: {
    search,
  },
  data() {
    return {
      Tips: "搜索内容", // 传给搜索组件的数据
      // data: "谷歌、微软Edge浏览器复制功能异常，怎么解决？",
      input: "", // 搜索
      dataArr: {}, //文本数据
      articleId: "", // 文章id
      CurrentPage: "", // 那个页面过来的，常见问题区/知识区
    };
  },
  created() {
    this.articleId = this.$route.query.category;
    // 区分知识区/常见问题
    this.CurrentPage = this.$route.query.CurrentPage;
    // /problem 调用常见问题区的数据接口
    if (this.CurrentPage == "/problem") {
      this.postGetProblemInfoById();
    } else {
      // 调用知识区接口
      this.postGetKnowledgeArticleById();
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    // 返回常见问题页面
    handelReturn() {
      if (this.CurrentPage == "/problem") {
        //跳转常见问题
        this.$router.push({
          path: "/problem",
        });
      } else {
        this.$router.push({
          path: "/knowledge",
        });
      }
    },
    // 文章内容接口
    postGetProblemInfoById() {
      var data = {
        data: { id: this.articleId },
      };
      // 调用文章内容接口
      postGetProblemInfoById(data).then((res) => {
        if (res.code == 0) {
          // 接口调用成功
          this.dataArr = res.data;
        } else {
          // 接口调用失败
          // this.$tool.PromptBox("error", res.msg);
        }
      });
    },
    // 知识区文章内容接口
    postGetKnowledgeArticleById() {
      var data = {
        data: { id: this.articleId },
      };
      // 调用文章内容接口
      postGetKnowledgeArticleById(data).then((res) => {
        if (res.code == 0) {
          // 接口调用成功
          this.dataArr = res.data;
        } else {
          // 接口调用失败
          // this.$tool.PromptBox("error", res.msg);
        }
      });
    },
    // 搜索函数
    handelScreen(val) {
      // 打开新窗口 跳转新页面  跳转搜索详情
      let routeData = this.$router.resolve({
        path: "/results",
        query: { category: val, CurrentPage: this.CurrentPage },
      });
      if (val != "") {
        window.open(routeData.href, "_blank");
      }
    },
  },
};
</script>

<style scoped lang="less">
.box1 {
  width: 100%;
  height: 100%;
}
// 搜索
.search-box {
  min-width: 1200px;
  height: 54px;
  margin: auto;
  margin-bottom: 50px;
  margin-top: 33px;
  display: flex;
  .search {
    width: 720px;
    height: 54px;
    line-height: 54px;
    margin: auto;
    display: flex;
    position: relative;
  }
}
// 搜索关键字
.keyword {
  width: 1184px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.Core {
  width: 1184px;
  min-height: 800px;
  margin: auto;
  // padding-top: 5px;
  display: flex;
  flex-direction: column;

  background: #ffffff;
  box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
  border-radius: 10px;
  // 全部问题
  .all-problem {
    width: 1100px;
    margin: 30px;
    font-family: FZLTCHK--GBK1-0;
    display: flex;
    flex-direction: column;
    .title {
      font-size: 18px;
      color: #333333;
      text-align: center;
      font-weight: 600;
      margin-bottom: 20px;
    }

    .num-p {
      width: 100%;
      text-align: right;
      letter-spacing: 0px;
    }
    /deep/p {
      font-size: 14px;
      color: #666666;
      letter-spacing: 1.5px;
      line-height: 30px;
      font-weight: 400;
      text-indent: 30px;
    }
    /deep/div {
      width: 100%;
      display: flex;
      flex-direction: column;
    }
    /deep/img {
      width: 500px;
      // border: 1px solid #666666;
      margin: 0 auto !important;
    }
  }
}
</style>
